import { render, staticRenderFns } from "./EditQuickCommentDialog.vue?vue&type=template&id=319b331e"
import script from "./EditQuickCommentDialog.vue?vue&type=script&lang=js"
export * from "./EditQuickCommentDialog.vue?vue&type=script&lang=js"
import style0 from "./EditQuickCommentDialog.vue?vue&type=style&index=0&id=319b331e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports